import React from 'react'
import { useSelector } from 'react-redux'
import {
  RootStoreModel,
  switchOffReleaseNotification,
  toggleSideChangelog,
  toggleSideHelp
} from '../../../../redux'
import { HelpPanel } from '../../..'
import { ChangelogPanel } from './components/changelog/changelogPanel'
import { Drawer, Typography, IconButton, useTheme, makeStyles } from '@material-ui/core'
import { HelpContent, HelpIndex } from './components/help'
import {} from './'
import { styles } from './sidePanel.styles'

export const SidePanel: React.FC<{}> = () => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const isOpenHelp = useSelector(
    (state: RootStoreModel) => state.layout && state.layout.sideHelpIsOpen
  )
  const isOpenChangelog = useSelector(
    (state: RootStoreModel) => state.layout && state.layout.sideChangelogIsOpen
  )

  const isOpen = isOpenHelp || isOpenChangelog

  const handleCloseDrawer = React.useCallback(() => {
    if (isOpenHelp) {
      toggleSideHelp()
    } else if (isOpenChangelog) {
      toggleSideChangelog()
      switchOffReleaseNotification()
    }
  }, [isOpenHelp, isOpenChangelog])

  const Panel = () => {
    if (isOpenHelp) {
      return <HelpPanel onHandleClose={handleCloseDrawer} />
    } else if (isOpenChangelog) {
      return <ChangelogPanel onHandleClose={handleCloseDrawer} />
    }

    return <></>
  }

  return (
    <Drawer open={isOpen} anchor="right" className={classes.drawerRoot}>
      <div className={classes.sideHelpContainer}>
        <div className={classes.cardRoot}>
          <Panel />
        </div>
      </div>
    </Drawer>
  )
}
